var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InvoicesContainer',{attrs:{"project":_vm.selectedProject,"year":_vm.selectedYear,"yearOptions":_vm.yearOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }